import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Fab from "@material-ui/core/Fab";
import VisibilityIcon from "@material-ui/icons/Visibility";

import "../../common/css/base.css";
import "../../common/css/dashboard.css";
import { fetchDashBoardSP } from "./service/service";
import { bindActionCreators } from "redux";
import { format } from "date-fns";
import { showHideDialogMapFromLogWalk } from "../sites/site/service/service";
import PlayCircleOutlineOutlinedIcon from "@material-ui/icons/PlayCircleOutlineOutlined";
import DrawingDialog from "../DrawingDialog";
import { MODE_DEVICE } from "components/sites/site/LogWalkViewer/constants";
import Pc from "../../common/breakpoints/Pc";
import Sp from "../../common/breakpoints/Sp";

class DashboardSP extends Component {
  constructor() {
    super();
    this.state = {
      sitesUC: null,
      isShowDialogDrawing: false,
      isDialogShow: false,
      times: new Date("2014-08-18T21:11:54")
    };
  }

  componentDidMount() {
    this.props.fetchDashBoardSP();
  }

  to = id => () => {
    this.props.history.push("/sp/sites/" + id);
  };

  showHideDialogDrawing = (sitesUC = null) => {
    this.setState({
      isShowDialogDrawing: !this.state.isShowDialogDrawing,
      sitesUC
    });
  };

  render() {
    const { dashboardSP } = this.props;
    const { isShowDialogDrawing, sitesUC } = this.state;
    return (
      <Grid className="dashboard-sp">
        <Grid>
          <Typography
            variant="h5"
            className="dashboard-sp-title font-family text-bold"
          >
            担当現場
          </Typography>
          <MenuList>
            {dashboardSP.map(item => (
              <MenuItem
                onClick={this.to(item.uniqueCode)}
                key={item.uniqueCode}
                className="dashboard-sp-item"
              >
                <Grid container justify="space-between" wrap="nowrap">
                  <Grid className="item-left">
                    <Typography
                      variant="subtitle2"
                      className="font-family grey-light white-space-normal"
                    >
                      {item.builderName}
                    </Typography>
                    <Typography
                      variant="h5"
                      className="text-bold font-family white-space-normal"
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="h6"
                      className="font-family grey-deep white-space-normal text-over-wrap"
                    >
                      {item.address}
                    </Typography>
                    {item.employeeNames.length > 0 && (
                      <Typography
                        variant="h6"
                        className="font-family grey-deep white-space-normal mt-20 lh-1-2"
                      >
                        {item.employeeNames.join("・")}
                      </Typography>
                    )}
                  </Grid>
                  <Grid className="item-right">
                    <Typography
                      variant="subtitle2"
                      className="font-family grey-light"
                    >
                      {item.lastRecordedAt
                        ? (format(new Date(item.lastRecordedAt), "yyyy年M月d日 HH:mm 更新"))
                        : (format(new Date(item.regisionDate), "yyyy年M月d日 HH:mm 現場登録"))
                      }
                    </Typography>
                    <Grid
                      item
                      xs={6}
                      className="s-ta-r "
                      onClick={e => e.stopPropagation()}
                    >
                      <Fab
                        className={
                          item.logWalkViewer
                            ? "white-text button-logWalk-sp mx-5"
                            : "white-text button-logWalk-sp-disable mx-5"
                        }
                        size="small"
                        onClick={e => {
                          if (item.logWalkViewer) {
                            this.showHideDialogDrawing(item.uniqueCode);
                          }
                          e.stopPropagation();
                        }}
                      >
                        <PlayCircleOutlineOutlinedIcon
                          style={{ textTransform: "none" }}
                        />
                      </Fab>
                    </Grid>
                  </Grid>
                </Grid>
              </MenuItem>
            ))}
          </MenuList>
        </Grid>
        <Pc>
          {isShowDialogDrawing && (
            // <DrawingDialog
            //   open={isShowDialogDrawing}
            //   onClose={this.showHideDialogDrawing}
            //   sitesUC={sitesUC}
            //   isSp={true}
            // />
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.PC}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
              isSp={true}
            />
          )}
        </Pc>
        <Sp>
          {isShowDialogDrawing && (
            // <DrawingDialog
            //   open={isShowDialogDrawing}
            //   onClose={this.showHideDialogDrawing}
            //   sitesUC={sitesUC}
            //   isSp={true}
            // />
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.SP}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
              isSp={true}
            />
          )}
        </Sp>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  dashboardSP: state.dashboardsReducer.dashboardSP,
  type: state.rootSitesReducer.siteInfoReducer.type
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchDashBoardSP: fetchDashBoardSP,
      showHideDialogMapFromLogWalk: showHideDialogMapFromLogWalk
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DashboardSP));
